export const clientcompliance = {
  getDetails,
};

export const originalEquipmentModels = [
  {
    name: "Automação",
    itemtype: "Peripheral",
  },
  {
    name: "Clima",
    itemtype: "Computer",
  },
  {
    name: "Energia",
    itemtype: "NetworkEquipment",
  },
  {
    name: "Conectividade",
    itemtype: "Printer",
  },
  {
    name: "Mobiliário",
    itemtype: "Phone",
  },
  {
    name: "Segurança",
    itemtype: "Monitor",
  },
  {
    name: "Civil",
    itemtype: "software",
  },
];

//*******ACTI Requests********


//Get Entity Definitios
function getDetails(user) {
  // console.log(user)


  var modalityOptions = [
    { id: 1, name: "Instalação" },
    { id: 2, name: "Comissionamento" },
    { id: 3, name: "Preventiva Padrão" },
    { id: 4, name: "Suporte Técnico" },
    { id: 5, name: "Corretiva Emergencial" },
    { id: 6, name: "Auditoria" },
    { id: 7, name: "As-Built" },
    { id: 8, name: "Start-Up" },
    { id: 9, name: "Treinamento" },
    { id: 10, name: "Consultoria" },
    { id: 11, name: "Preditiva" },
    { id: 12, name: "Corretiva Programada" },
    { id: 13, name: "Evolutiva" },
    { id: 14, name: "TI" },
    { id: 15, name: "Preventiva Crítica" },
  ];
  var categoryOptions = [
    { id: 1, name: "Automação" },
    { id: 2, name: "Civil" },
    { id: 3, name: "Clima" },
    { id: 4, name: "Energia" },
    { id: 5, name: "Segurança" },
    { id: 6, name: "Conectividade" }
  ];
  var urgencyOptions = [
    { id: 1, name: "Muito baixa" },
    { id: 2, name: "Baixa" },
    { id: 3, name: "Média" },
    { id: 4, name: "Alta" },
    { id: 5, name: "Muito alta" },
    { id: 6, name: "Crítica" },
  ];
  var equipmentModels = [
    {
      name: "Automação",
      itemtype: "Peripheral"
    },
    {
      name: "Clima",
      itemtype: "Computer"
    },
    {
      name: "Energia",
      itemtype: "NetworkEquipment"
    },
    {
      name: "Conectividade",
      itemtype: "Printer"
    },
    {
      name: "Mobiliário",
      itemtype: "Phone"
    },
    {
      name: "Segurança",
      itemtype: "Monitor"
    },
    {
      name: "Civil",
      itemtype: "software"
    }
  ];

  var typeOption = [ {
    name: "Incidente",
    id: 1
  },
    {
      name: "Requisição",
      id: 2
    },
  ];

  var statusOption = [ {
    name: "Novo",
    id: 1
  },
    {
      name: "Processando (atribuído)",
      id: 2
    },
    {
      name: "Processando (planejado)",
      id: 3
    },
    {
      name: "Pendente",
      id: 4
    },
    {
      name: "Solucionado",
      id: 5
    },
    {
      name: "Fechado",
      id: 6
    },
  ];


  user.categoryOptions = categoryOptions;
  user.modalityOptions = modalityOptions;
  user.urgencyOptions = urgencyOptions;
  user.equipmentModels = equipmentModels;
  user.typeOption = typeOption;
  user.statusOption = statusOption;
  user.convertStatus = [ "-", "Novo", "Atribuído", "Planejado", "Pendente", "Solucionado", "Fechado" ];
  user.convertPriority = [ "-", "Muito baixa", "Baixa", "Média", "Alta", "Muito Alta", "Crítica" ];
  user.convertModality = [
    "-",
    "Instalação",
    "Comissionamento",
    "Preventiva Padrão",
    "Suporte Técnico",
    "Corretiva Emergencial",
    "Auditoria",
    "As-Built",
    "Start-Up",
    "Treinamento",
    "Consultoria",
    "Preditiva",
    "Corretiva Programada",
    "Evolutiva",
    "TI",
    "Preventiva Crítica"
  ];
  user.convertCategories = [ "Automação", "Civil", "Clima", "Conectividade", "Energia", "Segurança" ];
  user.categoriesStyle = "standard";
  user.materialsPresentation = "hidden";
  user.approvalPresentation = "hidden";

  // Regra para CICC NACIONAL e MJSP
  if (user.activeentity == 149 || user.activeentity == 988 || user.activeentity == 596) { //added on NUCLEO DE TECNOLGIA for testing
    user.approvalPresentation = "presented";
    user.convertPriority = [ "-", "Não Crítico", "Baixa", "Média", "Alta", "Muito Alta", "Grave" ];
    user.urgencyOptions = [
      { id: 1, name: "Não Crítico" },
      { id: 2, name: "Baixa" },
      { id: 3, name: "Média" },
      { id: 4, name: "Alta" },
      { id: 5, name: "Muito Alta" },
      { id: 6, name: "Grave" },
    ];
    user.convertStatus = [ "-", "Aberto", "Aberto", "Aberto", "Suspenso", "Solucionado", "Fechado" ];
    user.statusOption = [ {
      name: "Aberto",
      id: 1
    },
      {
        name: "Aberto",
        id: 2
      },
      {
        name: "Aberto",
        id: 3
      },
      {
        name: "Suspenso",
        id: 4
      },
      {
        name: "Solucionado",
        id: 5
      },
      {
        name: "Fechado",
        id: 6
      },
    ];

  }


  // Regra para BB
  if (user.activeentity == 595) {
    user.categoriesStyle = "stricted";
    user.equipmentModels = [
      {
        name: "Sistemas",
        itemtype: "Printer"
      }
    ];
    user.categoryOptions = [
      { id: 6, name: "Conectividade" }
    ];
  }

  // Regra para PORTO SEGURO
  if (user.activeentity == 1021 || user.activeentity == 1033 || user.activeentity == 1034 || user.activeentity == 1035) {
    user.categoriesStyle = "stricted";
    user.materialsPresentation = "presented";

  }

  // Regra para CLARO
  if (user.activeentity == 1 || user.activeentity == 2 || user.activeentity == 119 || user.activeentity == 708 || user.activeentity == 709 || user.activeentity == 721) {
    user.categoriesStyle = "stricted";
    user.equipmentModels = [
      {
        name: "Automação",
        itemtype: "Peripheral"
      },
      {
        name: "Clima",
        itemtype: "Computer"
      },
      {
        name: "Energia",
        itemtype: "NetworkEquipment"
      },
      {
        name: "Cabling",
        itemtype: "Printer"
      },
      {
        name: "Incêndio",
        itemtype: "Monitor"
      },
      {
        name: "Civil",
        itemtype: "software"
      }
    ];
    user.convertCategories = [ "Automação", "Civil", "Clima", "Cabling", "Energia", "Incêndio" ];
    user.modalityOptions = [
      { id: 1, name: "Instalação" },
      { id: 3, name: "Preventiva Padrão" },
      { id: 4, name: "Suporte Técnico" },
      { id: 5, name: "Corretiva" },
      { id: 14, name: "TI" },
    ];
    user.materialsPresentation = "presented";

  }


  return user;
}
